import { render, staticRenderFns } from "./bloggerOrgin.vue?vue&type=template&id=c98e9b60&scoped=true&"
import script from "./bloggerOrgin.vue?vue&type=script&lang=js&"
export * from "./bloggerOrgin.vue?vue&type=script&lang=js&"
import style0 from "./bloggerOrgin.vue?vue&type=style&index=0&id=c98e9b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98e9b60",
  null
  
)

export default component.exports